import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets
import ElementUI from "element-ui";
import { Message } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import VCharts from "v-charts";
import CryptoJS from "crypto-js";

import "@/styles/index.scss"; // global css

import App from "./App";
import router from "./router";
import store from "./store";

// import "@/icons"; // icon // permission control
import { formatDate } from "./utils/date.js";

import VueQuillEditor from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/swiper-bundle.css";

import { baseUrl } from "@/utils/request";

import vueButtonEffect from "vue-button-effect";

import Carousel3d from "vue-carousel-3d";
Vue.use(Carousel3d);

Vue.use(vueButtonEffect);

Vue.use(VueAwesomeSwiper /* { default options with global component } */);

Vue.use(Loading);

Vue.use(VueQuillEditor /* { default global options } */);

Vue.use(ElementUI, { locale });
Vue.use(VCharts);

Vue.config.productionTip = false;
Vue.$message = Message;

Vue.filter("formatTime", function(time) {
  if (time == null || time === "") {
    return "";
  }
  let date = new Date(time);
  return formatDate(date, "yyyy-MM-dd hh:mm:ss");
});

Vue.filter("formatDate", function(time) {
  if (time == null || time === "") {
    return "";
  }
  let date = new Date(time);
  return formatDate(date, "yyyy-MM-dd");
});

Vue.filter("formatYear", function(time) {
  if (time == null || time === "") {
    return "";
  }
  let date = new Date(time);
  return formatDate(date, "yyyy");
});

Vue.filter("formatMonth", function(time) {
  if (time == null || time === "") {
    return "";
  }
  let date = new Date(time);
  return formatDate(date, "MM-dd");
});

Vue.mixin({
  methods: {
    getFromLocalstorage: function(name) {
      const _data = localStorage.getItem(name);
      if (_data) {
        if (name === "token") {
          let _unhash = this.unhash(_data, "xinlichangyuanshoulashou");
          let _split = _unhash.split("xinlichangyuan");
          return _split;
        } else {
          return JSON.parse(_data);
        }
      }
    },
    setLocalStorage: function(key, value) {
      localStorage.setItem(key, JSON.stringify(value));
    },
    hash: function(string, code) {
      let hash = CryptoJS.AES.encrypt(string, code).toString();
      console.log(hash, "hash");
      return hash;
    },
    unhash: function(hash, code) {
      let unhash = CryptoJS.AES.decrypt(hash, code);
      var originalText = unhash.toString(CryptoJS.enc.Utf8);
      console.log(originalText, "unhash");
      return originalText;
    },
    startLoading: function() {
      return Vue.$loading.show();
    },
    processImageUrl: function(url) {
      return baseUrl + url;
    }
  }
});

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js